import { jsx } from "react/jsx-runtime";
import { Text } from "@zillow/constellation-10";
const HEADING_FONT_CSS = {
  xs: {
    fontSize: {
      base: "heading-sm",
      xl: "heading-xs"
    },
    lineHeight: {
      base: "heading-sm",
      xl: "heading-xs"
    }
  },
  sm: {},
  md: {
    fontSize: {
      base: "heading-sm",
      md: "heading-md"
    },
    lineHeight: {
      base: "heading-sm",
      md: "heading-md"
    }
  },
  lg: {
    fontSize: {
      base: "heading-sm",
      md: "heading-md",
      xl: "heading-xl"
    },
    lineHeight: {
      base: "heading-sm",
      md: "heading-md",
      xl: "heading-xl"
    }
  }
};
const HEADING_MARGIN_CSS = {
  xs: {},
  sm: {
    marginBottom: "default"
  },
  md: {
    marginBottom: {
      base: "default",
      md: "loose"
    }
  },
  lg: {
    marginBottom: {
      base: "default",
      md: "loose"
    }
  }
};
const UpsellHeading = ({
  children,
  size
}) => /* @__PURE__ */ jsx(Text, { asChild: true, textStyle: "heading-sm", css: {
  color: "var(--heading)",
  ...HEADING_FONT_CSS[size],
  ...HEADING_MARGIN_CSS[size]
}, children: /* @__PURE__ */ jsx("p", { children }) });
export {
  UpsellHeading as default
};
